import { fetch } from '@/utils/http'

export default {
  hibeContractDetact: params => fetch('post', '/cbaas-service/v1/hibe/contractDetact', params),

  hibeContractInstall: params => fetch('post', '/cbaas-service/v1/hibe/contractInstall', params),

  init: params => fetch('post', '/cbaas-service/v1/hibe/init', params),

  getParams: params => fetch('post', '/cbaas-service/v1/hibe/getParams', params),

  genPrvKey: params => fetch('post', '/cbaas-service/v1/hibe/genPrvKey', params),

  paramsOnchain: params => fetch('post', '/cbaas-service/v1/hibe/paramsOnchain', params),

  paramsQuery: params => fetch('post', '/cbaas-service/v1/hibe/paramsQuery', params),

  cipherDataOnchain: params => fetch('post', '/cbaas-service/v1/hibe/cipherDataOnchain', params),
  cipherDataQuery: params => fetch('post', '/cbaas-service/v1/hibe/cipherDataQuery', params)
}
